import { Component, OnInit, Input } from '@angular/core';
import { FormField } from '../../../common/models/form-details.model';
import { WS10Paragraph } from '@vfde-fe/ngx-lib/brix/ws10-paragraph';
import { PARAGRAPH_SIZE } from 'src/app/common/constants/Defines';

/** ParagraphComponent */
@Component({
  selector: 'app-paragraph',
  templateUrl: './paragraph.component.html',
})
export class ParagraphComponent implements OnInit {
  /** paragrapghConfig */
  public paragrapghConfig: WS10Paragraph;

  /** formField */
  @Input() public formField: FormField;

  /** ngOnInit */
  public ngOnInit (): void {
    if (this.formField) {
      this.configureComponent(this.formField);
    }
  }

  /** configureComponent
   * @method configureComponent
   * @param {FormField} data
   */
  public configureComponent (data: FormField) {
    if (data.value) {
     this.paragrapghConfig = {
        size: PARAGRAPH_SIZE,
        text: data.value,
      };
    }
  }
}
